
import { CsnotesComponent } from './csnotes/csnotes.component';

import { IctpracticalComponent } from './ictpractical/ictpractical.component';
import { HardwareComponent } from './hardware/hardware.component';
import { HomeComponent } from './home/home.component';
import { SlideshowComponent } from './slideshow/slideshow.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component:HomeComponent
  },
  {
    path: 'aboutme',
    pathMatch: 'full',
    component: SlideshowComponent
  },
  {
    path: 'table',
    pathMatch: 'full',
    component: HardwareComponent
  },

  {
    path: 'graph',
    pathMatch: 'full',
    component: IctpracticalComponent 
  },
  {
    path: 'csnotes',
    pathMatch: 'full',
    component: CsnotesComponent
  },
 
 
  
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
